import { $fetch } from 'utils/request';
import { COUNTRIES_ROUTE } from 'utils/routes';
import { defaultLocale } from 'utils/translations';

type GetCountriesReturn = {
  countries: {
    id: string;
    name: string;
    languages: {
      id: string;
      name: string;
      default: boolean;
    }[];
    globale: boolean;
    esw: boolean;
  }[];
};

export async function getCountries({ locale = defaultLocale }: { locale?: string }) {
  try {
    const r = await $fetch<GetCountriesReturn>({ path: COUNTRIES_ROUTE, query: { profile: locale } });
    return r;
  } catch (error) {
    return null;
  }
}
